export enum JiraAvatarSizes {
  Size16 = '16x16',
  Size24 = '24x24',
  Size32 = '32x32',
  Size48 = '48x48',
}

export interface JiraAvatarUrlsDTO {
  [key: string]: string;
}

export interface JiraUserDTO {
  accountId: string;
  displayName: string;
  avatarUrls?: JiraAvatarUrlsDTO;
}

export class JiraUser {
  private readonly accountId: string;
  private readonly displayName: string;
  private readonly avatarUrls: JiraAvatarUrlsDTO;

  constructor({ accountId, displayName, avatarUrls }: JiraUserDTO) {
    this.accountId = accountId;
    this.displayName = displayName;
    this.avatarUrls = avatarUrls || {};
  }

  getAccountId(): string {
    return this.accountId;
  }

  getDisplayName(): string {
    return this.displayName;
  }

  getDevaultAvatarUrl(): string | null {
    if (!this.avatarUrls || !this.avatarUrls[JiraAvatarSizes.Size32]) {
      return null;
    }

    return this.avatarUrls[JiraAvatarSizes.Size32];
  }
}
